"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSizeDependencies = void 0;
var _dependenciesCompareNaturalGenerated = require("./dependenciesCompareNatural.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var setSizeDependencies = exports.setSizeDependencies = {
  compareNaturalDependencies: _dependenciesCompareNaturalGenerated.compareNaturalDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createSetSize: _factoriesAny.createSetSize
};